import { jblContent } from "../brandContent/jblBrandContent";
import BrandLogo from "/static/images/tenants/jbl/logo.svg";
import { jblPrize } from "../brandPrize/jblPrize";
import { jbl } from "../brandThemes/jbl";

export const JBL_brandVariables = {
  tenantId: "elgiganten-nbxpa", // For picking wich leaderboard to show
  themeId: "jbl",
  gameStyle: "cs2timed", // For picking wich leaderboard to show
  eventCode: "", // Needed for fetching correct challenge
  gameType: "CSGO", // What challenge game
  brandLogoType: "element", // "img" | "element" (svg)
  brandLogo: BrandLogo,
  brandLogoSize: 400,
  theme: jbl,
  content: jblContent,
  prize: jblPrize,

  leaderboardLength: 9,
  disclaimer: "Set the fastest time and win a",
};
